import classNames from 'classnames';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ACBadRequestError = ({
  className,
  to,
  href,
  'data-test-id': dataTestId = 'bad-request-error'
}) => /*#__PURE__*/_jsxs(UIErrorMessage, {
  className: classNames('bad-request-error', className),
  "data-test-id": dataTestId,
  type: "badRequest",
  children: [/*#__PURE__*/_jsxs("p", {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyCommon.errors.badRequest.somethingsGoneWrong"
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyCommon.errors.badRequest.refreshPage"
    })]
  }), (to || href) && /*#__PURE__*/_jsxs("p", {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyCommon.errors.filters.common.subtitle"
    }), /*#__PURE__*/_jsx("br", {}), to ? /*#__PURE__*/_jsx(UIRouterLink, {
      to: to,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyCommon.errors.filters.common.clearFilters"
      })
    }) : /*#__PURE__*/_jsx(UIButton, {
      href: href,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyCommon.errors.filters.common.clearFilters"
      })
    })]
  }), /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyCommon.errors.badRequest.keepsHappening"
    })
  })]
});
export default ACBadRequestError;